import { render, staticRenderFns } from "./GlobalFooterLink.vue?vue&type=template&id=6c083d81&"
import script from "./GlobalFooterLink.vue?vue&type=script&lang=ts&"
export * from "./GlobalFooterLink.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalFooterLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports